import React from "react";
import "./Sections.scss";

function QA3() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          And to do that you had to travel the world?
        </p>
        <p className="interview__interview__copy">
          To learn properly the trade, I had to travel around the world. I
          visited over a thousand factories, some Italian, some foreign, and met
          many different maestros. They were extremely interesting to me. But in
          the end, it was clear that I had to be different. I had to be myself.
          I had to be Roberto.
        </p>
      </div>
    </section>
  );
}

export default QA3;
